<div *ngIf="!imageUris || imageUris.length <= 0">There are no images to choose from.</div>
<div class="images">
    <img *ngFor="let uri of imageUris; let i = index" [src]="uri" (click)="selectImage(i)"
        [class.selected]="selectedIndex === i">
</div>